import Api from '../Api';

import { url } from './config';
import { PaymentsTerminal } from './types';

const api = new Api<PaymentsTerminal>(url);

export default api;
